import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isOver", "disabled"];
import styled from 'styled-components';
import AttachmentUploadDragAndDropWrapper from '../../attachments/components/AttachmentUploadDragAndDropWrapper';
import DragAndDropUploadOverlay from '../../attachments/components/DragAndDropUploadOverlay';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnifiedThreadViewWrapper = styled.div.withConfig({
  displayName: "UnifiedThreadViewWrapperWithDragUpload__UnifiedThreadViewWrapper"
})(["display:flex;flex-direction:column;height:100%;"]);
const UnifiedThreadViewWrapperWithDragUpload = ({
  children,
  onDropFiles,
  disabled
}) => {
  const renderContent = useCallback(_ref => {
    let {
        isOver,
        disabled: isDisabled
      } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/_jsxs(UnifiedThreadViewWrapper, Object.assign({
      "data-test-id": "UnifiedThreadViewWrapper-testid"
    }, props, {
      children: [children, /*#__PURE__*/_jsx(DragAndDropUploadOverlay, {
        isOver: isOver,
        disabled: isDisabled
      })]
    }));
  }, [children]);
  return /*#__PURE__*/_jsx(AttachmentUploadDragAndDropWrapper, {
    onDropFiles: onDropFiles,
    disabled: disabled,
    children: renderContent
  });
};
UnifiedThreadViewWrapperWithDragUpload.displayName = 'UnifiedThreadViewWrapperWithDragUpload';
export default UnifiedThreadViewWrapperWithDragUpload;